import { ReactNode } from 'react'
import cx from 'classnames'
import styles from './Button.module.css'

/**
 * 시안 `.btn` / `.btn.line` / `.btn.sm` / `.gsel`(ghost) 이식.
 * ghost 는 `.gsel` 과 스타일이 완전히 달라(라인 안 그룹 헤더용 소형 버튼) 별도 클래스로 둔다.
 */
export type ButtonProps = {
  variant?: 'solid' | 'line' | 'ghost'
  size?: 'md' | 'sm'
  disabled?: boolean
  onClick?: () => void
  children: ReactNode
  type?: 'button' | 'submit'
}

export const Button = ({
  variant = 'solid',
  size = 'md',
  disabled,
  onClick,
  children,
  type = 'button',
}: ButtonProps): JSX.Element => {
  if (variant === 'ghost') {
    return (
      <button type={type} className={styles.ghost} disabled={disabled} onClick={onClick}>
        {children}
      </button>
    )
  }

  return (
    <button
      type={type}
      className={cx(styles.btn, variant === 'line' && styles.line, size === 'sm' && styles.sm)}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
